import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, decimals = 2) {
  if (value === null || value === undefined) return 'N/A';
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export const formatMXN = formatCurrency;

export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined) return 'N/A';
  return new Intl.NumberFormat('es-MX', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatPercent(value, decimals = 2) {
  if (value === null || value === undefined) return 'N/A';
  if (value === -1) return 'N/A';
  if (value >= 999) return '>999%';
  return `${formatNumber(value, decimals)}%`;
}

export function formatMultiple(value) {
  if (value === null || value === undefined) return 'N/A';
  return `${formatNumber(value, 2)}x`;
}

export const STATUS_MAP = {
  draft: { label: 'Borrador', color: 'bg-slate-100 text-slate-600' },
  in_analysis: { label: 'En análisis', color: 'bg-blue-50 text-blue-600' },
  active: { label: 'Activo', color: 'bg-emerald-50 text-emerald-600' },
  en_planeacion: { label: 'En planeación', color: 'bg-amber-50 text-amber-600' },
  en_preventa: { label: 'En preventa', color: 'bg-cyan-50 text-cyan-600' },
  en_construccion: { label: 'En construcción', color: 'bg-orange-50 text-orange-600' },
  en_ventas: { label: 'En ventas', color: 'bg-purple-50 text-purple-600' },
  completado: { label: 'Completado', color: 'bg-emerald-100 text-emerald-700' },
  archived: { label: 'Archivado', color: 'bg-gray-100 text-gray-500' },
};

export const ROLE_MAP = {
  super_admin: 'Super Admin',
  owner: 'Propietario',
  analyst: 'Analista',
  viewer: 'Visor',
};
